import { pageTypes } from 'config/pageTypes';
import Locker1 from 'assets/images/psp/FeaturedImages/storage-unit.webp';
import Locker2 from 'assets/images/psp/FeaturedImages/climate2.webp';
import Locker3 from 'assets/images/psp/FeaturedImages/storage-unit-5x5.webp';
import Locker4 from 'assets/images/psp/FeaturedImages/stuff-in-unit.webp';

import locker2x2 from 'assets/images/psp/Locker/2x2.svg';
import locker3x3 from 'assets/images/psp/Locker/3x3.svg';
import locker3x4 from 'assets/images/psp/Locker/3x4.svg';
import locker4x4 from 'assets/images/psp/Locker/4x4.svg';
import locker4x5 from 'assets/images/psp/Locker/4x5.svg';

import weather from 'assets/images/psp/Locker/weather.svg';
import cartMan from 'assets/images/psp/Locker/cart-man.svg';
import home from 'assets/images/psp/Locker/home.svg';
import booksIcon from 'assets/images/psp/Locker/books.svg';
import musicIcon from 'assets/images/psp/Locker/musical-instrument.svg';

import LockerAltImage from 'assets/images/sgp/alt-content-images/alt-content-image-optimized.webp';
import StorageLocker from 'assets/images/psp/FeaturedImages/know-storage-locker.webp';
import LockerHero from 'assets/images/psp/hero/locker-hero.webp';

const reviews = [
	{
		reviewTitle: 'It was fast and simple to make the reservation…',
		reviewRating: 5,
		reviewText:
			"It was fast and simple to make the reservation and didn't cost anything to reserve a storage locker",
		reviewerInitials: 'PF',
		link: 'https://www.trustpilot.com/reviews/675c601d7395304ef617d3ce',
		reviewerName: 'Parker Fields',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Through the SpareFoot site I was able to reserve and…',
		reviewRating: 5,
		reviewText:
			'Through the app I was able reserve and book a unit / locker on the date and time I chose made it more convenient for the whole family.',
		reviewerInitials: 'MT',
		link: 'https://www.trustpilot.com/reviews/66b8b12305b7b62cadf17a7f',
		reviewerName: 'Leeann Lopez',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'It was easy and quick to rent a locker…',
		reviewRating: 5,
		reviewText:
			'It was easy and quick to rent a locker the same day, the reservation was confirmed immediately and I was on my way!',
		reviewerInitials: 'JH',
		link: 'https://www.trustpilot.com/reviews/6408d8e4e27b60c7362f2784',
		reviewerName: 'Joe Haskins',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Quick, easy and to the point reservations.',
		reviewRating: 5,
		reviewText:
			'I was able to reserve a storage locker quick, easy and to the point. I selected the location, size, and type of storage in minutes on the website. Thanks!',
		reviewerInitials: 'SW',
		link: 'https://www.trustpilot.com/reviews/63568c8f8056669a30a9c65b',
		reviewerName: 'Stearling Williams',
		reviewDate: 'January 3rd, 2023',
	},
];

export const alternateContentData = {
	props: {
		type: 'alternatingContent',
		title: 'Looking for a Small Storage Unit?',
		description:
			'If you’re here, chances are that you’re looking for a small storage unit to give your stuff a new home. Lucky for you, SpareFoot has a variety of storage unit sizes to suit your small storage needs. Here’s your Goldilocks storage unit menu to help you find the best storage space:',
		additionalProps: {
			paragraph: {
				color: 'black',
			},
		},
		content: [
			{
				image: LockerAltImage,
				description: `**Medium Units:** 10x10, 10x15, 5x15
					\n **Small Units:** 5x5, 5x10, Mini storage, Storage lockers (*you are here*)
					\n **Large Units:** 10x20, 10x25, 10x30`,
			},
		],
	},
};
export const alternateContentData2 = {
	props: {
		type: 'alternatingContent',
		title: 'Know Your Storage Sizes: Storage Locker Edition',
		additionalProps: {
			paragraph: {
				color: 'black',
			},
		},
		content: [
			{
				image: StorageLocker,
				title: 'What is a Storage Locker? ',
				description:
					'Storage lockers are a small but mighty storage solution perfect for storing seasonal clothing, decorations, and apartment or studio overflow. Storage lockers are classified as storage space with a smaller footprint than mini storage units and traditional storage units, making them more affordable and favorable for city dwellers who have trouble making extra space in their homes. ',
			},
		],
	},
};

const faqs = [
	{
		question: 'What is a storage locker?',
		answer: `A storage locker is a secure storage unit designed for smaller storage needs. These affordable storage units range from 2x2 up to 4x5, and are perfect for storing seasonal items, collections, or overflow belongings without renting a full-sized storage unit. Unlike gym lockers, storage lockers are usually in [climate-controlled facilities](https://www.sparefoot.com/climate-controlled-storage.html) with 24/7 access, security systems, and professional management.
			\n\nThey're the sweet spot between cramming everything into your closets and paying for more storage space than you need. If you’re looking for a storage unit that offers 5x5 to [5x10 feet of space](https://www.sparefoot.com/blog/5x10-storage-unit-size-guide), you’ll want to look into mini storage. For even bigger storage needs, your safest bet will be a traditional storage unit.`,
	},
	{
		question: 'How much does a storage locker cost for a year?',
		answer:
			'Storage locker costs vary by size and location, but expect to pay $300-$1,800 annually. Small 2x2 or 3x3 lockers typically run $25-$75 monthly ($300-$900/year), while larger 4x5 units cost $50-$150 monthly. Urban areas charge higher prices than suburban locations, as demand is high.\n\n' +
			'Many facilities offer discounts for annual payments, first-month free promotions, or seasonal deals. Through SpareFoot, you can compare prices across multiple facilities in your area to find the best rates and take advantage of exclusive online discounts that can save you hundreds per year.',
	},
	{
		question: 'What is the cheapest storage option?',
		answer: 'The cheapest storage option is typically a small 2x2 or 3x3 storage locker, starting around $25-$40 per month, depending on your location. These compact units are perfect for documents, small seasonal items, or personal belongings you don\'t access frequently. However, the "cheapest" option should match your actual needs—cramming everything into a too-small space often leads to renting additional units later. SpareFoot helps you find affordable storage lockers by showing you available units in your area, so you can compare prices and reserve instantly. ',
	},
	{
		question: 'Can I rent a 10x20 storage locker?',
		answer: `A [10x20 unit is typically called a standard storage](https://www.sparefoot.com/blog/10x20-storage-unit-size-guide) unit rather than a "locker". Storage lockers generally refer to smaller spaces up to 5x10. These large units offer 200 square feet of space, enough for a 3-4 bedroom house's worth of belongings, vehicles, or extensive business inventory. While they're beyond locker size, 10x20 units are popular for major moves, long-term storage, or business needs. SpareFoot's search tool lets you filter by size to find 10x20 units in your area and compare prices across multiple facilities.`,
	},
	{
		question: 'What can I fit in a 4x5 storage locker?',
		answer: "A 4x5 storage locker offers 20 square feet of space—about the size of a small bedroom or large walk-in closet. You can typically fit a bedroom set, including a mattress and box spring, a dresser, nightstand, and several boxes of belongings. Other items that work well include multiple appliances (washer, dryer, or refrigerator), extensive seasonal decorations, sports equipment collections, or small business inventory. The key is stacking efficiently and using vertical space—most lockers have shorter ceilings than traditional units. Think of it as enough room for one room's worth of furniture plus boxes, or several rooms' worth of smaller items and seasonal goods.",
	},
	{
		question: 'Do I need to buy a lock for a storage locker?',
		answer: `Yes, you'll need to provide your [lock for most storage lockers](https://www.sparefoot.com/blog/all-about-self-storage-locks)—facilities typically don't include locks in the rental price. We recommend a high-quality disc lock or cylinder lock designed for outdoor use, as they're more secure and weather-resistant than basic padlocks. Some facilities sell locks on-site, but buying your own ensures you control all the keys. Avoid cheap locks that can be easily cut or picked—your belongings deserve better protection.`,
	},
];

export const LockerContent = {
	type: 'Locker',
	pageType: pageTypes.SGP,
	sections: [
		{
			title: 'Locker Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'locker-storage-hero',
					background: 'lighterYellow',
					pageType: 'SGP',
					props: {
						content: {
							inputLabel: 'Find Your Ideal Storage Lockers',
							title: 'Rent a Storage Locker Near You',
							pageType: 'SGP',
							description:
								"Your apartment closets are bursting, your garage is a maze of boxes, and you're tripping over holiday lights in July—sound familiar? When you need a little extra breathing room without breaking the bank, small storage lockers offer the perfect solution for life's overflow. These compact, affordable units are ideal for storing seasonal items, sports equipment, holiday decorations, or those [collectibles you can't quite part with](https://www.sparefoot.com/blog/incredible-extreme-collectors-reveal-their-storage-secrets). Affordable storage lockers give you organized, accessible space that keeps your home comfortable and your belongings safe.",
							image: LockerHero,
							CTAText: 'Reserve Yours Now',
						},
						additionalProps: {
							heading: {
								family: 'rounded',
							},
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},
		{
			title: 'alternate content',
			modules: [
				{
					type: 'alternatingContent',
					props: alternateContentData,
					id: 'locker-alternate-content',
				},
			],
		},
		{
			title: 'alternate content',
			background: 'gray',
			modules: [
				{
					type: 'alternatingContent',
					props: alternateContentData2,
					id: 'locker-alternate-content',
				},
			],
		},
		{
			title: 'Icon Content Block',
			modules: [
				{
					type: 'IconContentBlock',
					props: {
						title: 'Understanding Storage Locker Sizes',
						headerContent: {
							prefix: '## Small Locker, Big Benefits',
							title: 'Understanding Storage Locker Sizes',
							description: `The [Self Storage Size Guide](https://www.sparefoot.com/storage-unit-size-guide.html) will help you figure out if you need a locker, mini storage, or an even larger self-storage unit, but if you’ve got your heart set on a cheap storage locker, here’s what you need to know about your size options.`,
						},
						itemsContent: {
							items: [
								{
									icon: locker2x2,
									title: '### 2x2 Storage Locker',
									description:
										'Fits small items like documents, seasonal clothing, small electronics, or a few boxes of personal belongings.',
								},
								{
									icon: locker3x3,
									title: '### 3x3 Storage Locker',
									description:
										'Fits several boxes, seasonal decorations, small furniture pieces, sports equipment, or business inventory.',
								},
								{
									icon: locker3x4,
									title: '### 3x4 Storage Locker',
									description:
										'Fits small furniture pieces, appliances like a washer or dryer, boxes of household items, or small business supplies.',
								},
								{
									icon: locker4x4,
									title: '### 4x4 Storage Locker',
									description:
										'Fits the contents of a bathroom or office, including lamps, a small desk, some boxes, and seasonal items.',
								},
								{
									icon: locker4x5,
									title: '### 4x5 Storage Locker',
									description:
										'Fits compact bedroom sets, appliances, extensive seasonal decorations, or small business inventory and equipment.',
								},
							],
						},
						contentType: 'row-type',
					},
				},
			],
		},
		{
			title: 'icon content block',
			background: 'gray',
			modules: [
				{
					type: 'IconContentBlock',
					props: {
						headerContent: {
							title: 'How to Use a Storage Locker',
							description:
								'Both small storage lockers and large storage lockers are more compact than your standard 5x10 or 10x10 storage unit, but they still pack a big punch when you need more space at home or in the office.',
						},
						itemsContent: {
							items: [
								{
									icon: weather,
									title: '### Seasonal Storage',
									description:
										'Store holiday decorations, seasonal clothing, inventory, office supplies, and more.',
								},
								{
									icon: cartMan,
									title: '### Life Transitions',
									description:
										'Temporary storage for college dorm overflow, moving between homes, and deployment scenarios.',
								},
								{
									icon: musicIcon,
									title: '### Hobby & Collections',
									description:
										'Store art supplies, instruments, sports gear, collectibles, and more.',
								},
								{
									icon: home,
									title: '### Space Optimization',
									description:
										'Ideal for [apartment decluttering](https://www.sparefoot.com/blog/what-to-keep-when-you-move), garage overflow, business documents, and lesser-used appliances.',
								},
								{
									icon: booksIcon,
									title: '### Emergency Backup',
									description:
										'Keep important documents, heirlooms, clothing, and emergency supplies safe and accessible.',
								},
							],
						},
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						pageType: 'SGP',
						title: "It's Easy to Find & Reserve a Storage Locker with SpareFoot",
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Storage Locker Size FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						title: 'Learn More About Storage Unit Size Options',
						pageType: 'SGP',
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'August 7, 2025',
								image: Locker1,
								link: 'https://www.sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
								content:
									'How to Pick the Right Size Self Storage Unit',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: Locker2,
								link: 'https://www.sparefoot.com/blog/how-are-storage-units-measured',
								content: 'How Are Storage Units Measured?',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: Locker3,
								link: 'https://www.sparefoot.com/blog/5x5-storage-unit-size-guide',
								content:
									'What Can You Fit Inside a 5x5 Storage Unit?',
							},
							{
								title: 'Self Storage',
								date: 'October 29, 2025',
								image: Locker4,
								link: 'https://www.sparefoot.com/blog/50-things-you-can-store-in-5x10-storage-unit',
								content:
									'50 Things That Fit Inside a 5x10 Storage Unit',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			modules: [
				{
					type: 'links',
					props: {
						pageType: 'SGP',
						title: 'More Ways to Store',
						cards: ['College', '24Hour', 'Mini', '5x5'],
					},
				},
			],
		},
		{
			title: 'nearby units',
			background: 'gray',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
